import api, {type ApiResponse, doError} from "@/axios.js";
import {defineStore} from 'pinia'
import type {AxiosError} from "axios";

export interface InfosInterface {
    id: number;
    name: string;
    url: string;
    short_description: string;
    description: string;
    translations?:{
        name:{
            [key:string]:string
        },
        short_description:{
            [key:string]:string
        },
        description:{
            [key:string]:string
        }
    }
    photos:{
        icon:string
        thumb:string
        photo:string
    };
}

export const useInfosStore = defineStore('infos', {
    state: () => ({
        _list: null as InfosInterface[] | null,
    }),
    getters: {
        list: (state) => state._list,

    },
        actions: {
            async load(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<InfosInterface[]>>('/infos');
                    this._list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async getSingle(id: number): Promise<InfosInterface|undefined> {
                try {
                    const response = await api.get<ApiResponse<InfosInterface>>(`/infos/${id}`);
                    return response.data.data;
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async loadInfo(url: string): Promise<InfosInterface|undefined> {
                try {
                    const response = await api.get<ApiResponse<InfosInterface>>(`/get-info/${url}`);
                    return response.data.data;
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async destroy(id: number): Promise<void> {
                try {
                    await api.delete(`/infos/${id}`);
                    this._list = this._list?.filter(item => item.id !== id) as InfosInterface[];
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
            async update(form: InfosInterface) {
                try {
                    const response=await api.put(`/infos/${form.id || 0}`, form);
                    const index = this._list?.findIndex(item => item.id === form.id);
                    if (index !== -1 && index !== undefined) {
                        this._list![index] = response.data.data;
                    } else {
                        this._list?.push(response.data.data);
                    }
                    return response.data.data.id;
                }
                catch (err: AxiosError | any) {
                    doError(err);
                }
            },
        }
})